import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { generalService } from '../../services/general.service';
import { Compania } from '../../models/compania';
import { Lookup } from '../../models/Lookup';
@Component({
  selector: 'my-compania-detalle',
  styleUrls: [], 
  templateUrl: 'compania-detalle.component.html',
  providers: [generalService]
})
export class CompaniaDetalleComponent implements OnInit {
 @Input() compania: Compania;
formCompania: FormGroup;
titulo = "";
isUpdate: boolean;
compania_id: string;
list: any;
reader: FileReader;

listTipoPagoNomina: Lookup[] = [];
listDayOfWeek: Lookup[] = [];
requiredDayOfWeek: boolean = true;
LOOKUP_TYPE_TPN = 'TYPE OF PAYROLL';
LOOKUP_TYPE_DAY = 'DAY OF WEEK';

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private route: ActivatedRoute,
		private _generalService: generalService
		) {
		this.list = new Object();
		this.compania = new Compania();
		this.formCompania = new FormGroup({});
		this.compania_id = this.route.snapshot.paramMap.get('id');
		//Usar en caso de emergencia con el router
		// this.router.events.subscribe(path => {
		//   console.log('path = ', path);
		// });

	}

	ngOnInit() {
		this.buildForm();
		this.initNewOrUpdate();		
    this.route.params.subscribe(params => {
      if(this.compania_id != params['id']){
          this.compania_id = params['id'];
          this.initNewOrUpdate();// reset and get based on new :id
      }
    });
  	}

  	getCompania(id:any){
	    this._generalService.metodoCall(`compania/consultarCompania/${id}`).subscribe(
	        result => {
        		let res = JSON.parse(result);
	        	if(res.some(e => true)){
					this.compania = res[0];
              this.titulo = "Actualizar Compañia"
              this.isUpdate = true;
	        		//this.personal.DATE_OF_BIRTH = new Date(this.personal.DATE_OF_BIRTH);
	        	}
	        	else
					this.router.navigate(['../', 'N'], {relativeTo: this.route });
					

          	},
	        error => {
	          console.log(<any>error);
	        }
      	);
	  }

	  getLookupPorTipoPagoNomina(){

	    this._generalService.metodoCall(`lookup/consultarPorTipo/?tipo=` + this.LOOKUP_TYPE_TPN).subscribe(
	        result => {
				let res = JSON.parse(result);
				this.listTipoPagoNomina = res;
          	},
	        error => {
	          console.log(<any>error);
			},
			() => {
				this.getLookupPorDayOfWeek();
			}
      	);
	  }

	  getLookupPorDayOfWeek(){
	    this._generalService.metodoCall(`lookup/consultarPorTipo/?tipo=` + this.LOOKUP_TYPE_DAY).subscribe(
	        result => {
				let res = JSON.parse(result);
				this.listDayOfWeek = res;
          	},
	        error => {
	          console.log(<any>error);
			},
			() => {
				if(this.compania_id == 'N'){
					this.titulo = "Nueva Compañia"
					this.isUpdate = false;
					this.compania = new Compania();
				 }
				 else
				   this.getCompania(this.compania_id);  	
			}
      	);
	  }
	  
	  selectedTipoPagoNomina(event: any) {
		if (event !== null && event !== undefined) {
			var name = this.listTipoPagoNomina.find(x=>x.LOOKUP_ID == event).MEANING;
			if( name === 'Semanal'){
				this.requiredDayOfWeek = false;
				this.formCompania.controls['ID_LOOKUP_DAY'].setValidators([Validators.required]);
				if(this.compania.ID_LOOKUP_DAY === null) {
					this.compania.ID_LOOKUP_DAY = this.listDayOfWeek[0].LOOKUP_ID;
				}
			}else {
				this.requiredDayOfWeek = true;
				this.compania.ID_LOOKUP_DAY = null;
				this.formCompania.controls['ID_LOOKUP_DAY'].setValidators(null);
			}
		} else {
			this.requiredDayOfWeek = true;
			this.compania.ID_LOOKUP_DAY = null;
			this.formCompania.controls['ID_LOOKUP_DAY'].setValidators(null);
		}
	  }

  	updateCompania(){
		console.log(this.compania);
  		this._generalService.metodoCallParams(this.compania, "compania/actualizarCompania").subscribe(
          result => {
          	this._generalService.toastCall(result.message);
           
          },
          error => {
            console.log(<any>error);
          }
      ); 
  	}

  	createCompania(){
  		this._generalService.metodoCallParams(this.compania, "compania/agregarCompania").subscribe(
          result => {
          	this._generalService.toastCall(result.message);
			 
       this.router.navigate(['../', result.data], {relativeTo: this.route });
          },
          error => {
            console.log(<any>error);
          }
      ); 
  	}

  	onSubmit() {      
  	  if(this.isUpdate)
  	  	this.updateCompania();
  	  else
  	  	this.createCompania();
      
  	}

    back(){
       this.router.navigate(['../'],{ relativeTo: this.route });
    }

  	initNewOrUpdate(){
		this.getLookupPorTipoPagoNomina();
		// this.getLookupPorDayOfWeek();
		 	
  	}

  

  	buildForm() {
    	this.formCompania = this.formBuilder.group({
	      Nombre: this.formBuilder.control(null,[Validators.required, Validators.maxLength(101)]),
	      //Numero: this.formBuilder.control(null, [Validators.required, Validators.maxLength(20)]),
		  ID_LOOKUP_TPN: this.formBuilder.control(null, [Validators.required]),
		  ID_LOOKUP_DAY: this.formBuilder.control(null),
		  suburbControl: this.formBuilder.control(null)
		});
    }
}


// WEBPACK FOOTER //
// ./src/app/compania/agregar-editar/compania-detalle.component.ts